import { useState, useCallback, useRef, useEffect, useContext } from "react";
import courtImage from './field/assets/3d.jpg';
import axios from 'axios';
import { Alert, Form, Button } from 'react-bootstrap';
import moment from 'moment';
import {Link,NavLink,useNavigate,useParams } from 'react-router-dom'
import { UserContext } from '../context/UserContext';

// ─── Mock Data (fallback) ─────────────────────────────────────────────────────
const MOCK_PLAYERS = [
  // { id: 1, fullname: "James Williams", position: "PG", team_id: 1, offense_rating: 88, defense_rating: 72, ball_handling: 90, percentage_2pt: 54, percentage_3pt: 38, percentage_ft: 85, speed: 80, age: 26, tag: "Starter", height: 188, weight: 85, country: "USA", orientation: "Right", avatar_url: "https://i.pravatar.cc/150?img=1" },
  // { id: 2, fullname: "Marcus Johnson", position: "SG", team_id: 1, offense_rating: 82, defense_rating: 78, ball_handling: 84, percentage_2pt: 50, percentage_3pt: 42, percentage_ft: 88, speed: 85, age: 24, tag: "Scorer", height: 195, weight: 90, country: "USA", orientation: "Right", avatar_url: "https://i.pravatar.cc/150?img=2" },
  // { id: 3, fullname: "David Chen",     position: "SF", team_id: 1, offense_rating: 75, defense_rating: 85, ball_handling: 76, percentage_2pt: 48, percentage_3pt: 36, percentage_ft: 79, speed: 82, age: 27, tag: "Two-Way", height: 201, weight: 98, country: "China", orientation: "Right", avatar_url: "https://i.pravatar.cc/150?img=3" },
  // { id: 4, fullname: "Andre Smith",    position: "PF", team_id: 1, offense_rating: 79, defense_rating: 90, ball_handling: 70, percentage_2pt: 56, percentage_3pt: 28, percentage_ft: 72, speed: 74, age: 29, tag: "Anchor", height: 206, weight: 110, country: "USA", orientation: "Right", avatar_url: "https://i.pravatar.cc/150?img=4" },
  // { id: 5, fullname: "Tyler Brooks",   position: "C",  team_id: 1, offense_rating: 71, defense_rating: 93, ball_handling: 65, percentage_2pt: 60, percentage_3pt: 20, percentage_ft: 65, speed: 68, age: 30, tag: "Rim Protector", height: 213, weight: 120, country: "USA", orientation: "Right", avatar_url: "https://i.pravatar.cc/150?img=5" },
  // { id: 6, fullname: "Kevin Moore",    position: "PG", team_id: 2, offense_rating: 86, defense_rating: 74, ball_handling: 88, percentage_2pt: 52, percentage_3pt: 40, percentage_ft: 87, speed: 88, age: 23, tag: "Playmaker", height: 185, weight: 82, country: "Canada", orientation: "Left", avatar_url: "https://i.pravatar.cc/150?img=6" },
  // { id: 7, fullname: "Carlos Rivera",  position: "SG", team_id: 2, offense_rating: 80, defense_rating: 80, ball_handling: 82, percentage_2pt: 49, percentage_3pt: 39, percentage_ft: 82, speed: 83, age: 25, tag: "Guard", height: 193, weight: 88, country: "Spain", orientation: "Right", avatar_url: "https://i.pravatar.cc/150?img=7" },
  // { id: 8, fullname: "Jamal Turner",   position: "SF", team_id: 2, offense_rating: 77, defense_rating: 83, ball_handling: 78, percentage_2pt: 47, percentage_3pt: 34, percentage_ft: 77, speed: 80, age: 28, tag: "Wing", height: 203, weight: 100, country: "France", orientation: "Right", avatar_url: "https://i.pravatar.cc/150?img=8" },
  // { id: 9, fullname: "Darius Hill",    position: "PF", team_id: 2, offense_rating: 83, defense_rating: 87, ball_handling: 68, percentage_2pt: 55, percentage_3pt: 30, percentage_ft: 70, speed: 76, age: 31, tag: "Veteran", height: 208, weight: 112, country: "USA", orientation: "Right", avatar_url: "https://i.pravatar.cc/150?img=9" },
  // { id: 10, fullname: "Elijah Grant",  position: "C",  team_id: 2, offense_rating: 69, defense_rating: 95, ball_handling: 62, percentage_2pt: 62, percentage_3pt: 18, percentage_ft: 60, speed: 65, age: 28, tag: "Defensive Wall", height: 215, weight: 125, country: "USA", orientation: "Right", avatar_url: "https://i.pravatar.cc/150?img=10" },
];

// ─── Zone layout ──────────────────────────────────────────────────────────────
const BBALL_ZONES = {
  "home-1": { top: "50%", left: "32%", label: "PG" },
  "home-2": { top: "32%", left: "24%", label: "SG" },
  "home-3": { top: "68%", left: "22%", label: "SF" },
  "home-4": { top: "42%", left: "17%", label: "PF" },
  "home-5": { top: "58%", left: "16%", label: "C"  },
  "away-1": { top: "50%", left: "68%", label: "PG" },
  "away-2": { top: "32%", left: "76%", label: "SG" },
  "away-3": { top: "68%", left: "78%", label: "SF" },
  "away-4": { top: "42%", left: "83%", label: "PF" },
  "away-5": { top: "58%", left: "84%", label: "C"  },
};

// const BBALL_STATS = [
//   { key: "ball_handling",  label: "Handling (HAN)" },
//   { key: "percentage_2pt", label: "2PT (%)" },
//   { key: "percentage_3pt", label: "3PT (%)" },
//   { key: "percentage_ft",  label: "FT (%)" },
//   { key: "speed",          label: "Speed (SPD)" },
// ];


const BBALL_STATS = [
  { key: "Ball_handling",  label: "Handling (HAN)" },
  { key: "Percentage_2pt", label: "2PT (%)" },
  { key: "Percentage_3pt", label: "3PT (%)" },
  { key: "Percentage_FT",  label: "FT (%)" },
  { key: "Speed",          label: "Speed (SPD)" },
];

const INITIAL_COURT = Object.fromEntries(Object.keys(BBALL_ZONES).map(k => [k, null]));

// ─── Helpers ──────────────────────────────────────────────────────────────────
function positionMatches(playerPos, expectedPos) {
  if (!playerPos || !expectedPos) return false;
  const p = playerPos.toUpperCase().trim();
  const e = expectedPos.toUpperCase().trim();
  if (p === e) return true;
  const map = {
    "POINT GUARD": "PG", "SHOOTING GUARD": "SG", "SMALL FORWARD": "SF",
    "POWER FORWARD": "PF", "CENTER": "C",
  };
  return map[p] === e;
}

function calcTeamStats(playerIds, allPlayers) {
  const players = playerIds.map(id => allPlayers.find(p => p.id == id)).filter(Boolean);
  // console.log(players)
  // console.log(BBALL_STATS)
  const stats = BBALL_STATS.map(({ key, label }) => {
    const avg = players.length
      ? (players.reduce((s, p) => s + parseFloat(p[key] || 0), 0) / players.length).toFixed(1)
      : 0;
    return { key, label, avg: parseFloat(avg) };
  });

  //console.log(stats)
  return { count: players.length, stats };
}

function generateInsight(home, away) {
  if (!home.count && !away.count) return "Place players on the court to receive strategy analysis...";
  if (home.count > 0 && home.count < 5) return `Your team has ${home.count} player${home.count > 1 ? "s" : ""}. Complete the starting 5 for full analysis.`;
  if (home.count === 5 && away.count === 5) {
    const shoot = s => s.stats.find(x => x.key === "Percentage_2pt")?.avg ?? 0;
    const handling = s => s.stats.find(x => x.key === "Ball_handling")?.avg ?? 0;
    const speed = s => s.stats.find(x => x.key === "Speed")?.avg ?? 0;
    const hs = (shoot(home) + (home.stats.find(x => x.key === "Percentage_3pt")?.avg ?? 0)) / 2;
    if (hs > 45 && hs > speed(away)) return "Your lineup has amazing shooters! Spread the floor and focus on kick-out 3-pointers.";
    if (speed(away) > handling(home) + 10) return "The opponent is much faster. Be careful of turnovers and transition fast-breaks!";
    if (handling(home) > 85) return "Great ball handling in your team. Focus on Pick & Roll to dismantle their defense.";
    return "Very balanced matchup. Victory will come down to rebounds and free throw execution.";
  }
  return "Place all players on both sides to get a full matchup analysis.";
}

function statBarColor(val) {
  if (val >= 80) return "linear-gradient(90deg,#10b981,#34d399)";
  if (val < 50)  return "linear-gradient(90deg,#ef4444,#f87171)";
  return "linear-gradient(90deg,#f59e0b,#fbbf24)";
}

// ─── Toast ────────────────────────────────────────────────────────────────────
function Toast({ message, onDone }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const t1 = setTimeout(() => setVisible(true), 10);
    const t2 = setTimeout(() => setVisible(false), 3500);
    const t3 = setTimeout(onDone, 3900);
    return () => [t1, t2, t3].forEach(clearTimeout);
  }, [onDone]);
  return (
    <div style={{
      position: "fixed", bottom: 30, left: "50%",
      transform: `translateX(-50%) translateY(${visible ? "0" : "100px"})`,
      opacity: visible ? 1 : 0,
      background: "rgba(15,23,42,0.95)", backdropFilter: "blur(10px)",
      border: "1px solid #ef4444", color: "white", padding: "15px 25px",
      borderRadius: 12, fontSize: 14, fontWeight: 600, fontFamily: "'Inter',sans-serif",
      boxShadow: "0 10px 30px rgba(0,0,0,0.5),0 0 15px rgba(239,68,68,0.3)",
      display: "flex", alignItems: "center", gap: 12, zIndex: 9999,
      transition: "all 0.4s cubic-bezier(0.175,0.885,0.32,1.275)", pointerEvents: "none",
    }}>
      <i className="fa-solid fa-circle-exclamation" style={{ fontSize: 20, color: "#ef4444" }} />
      {message}
    </div>
  );
}

// ─── Player Modal ─────────────────────────────────────────────────────────────
function PlayerModal({ player, onClose, onPlace, isOnCourt, onRemove }) {
  const [show, setShow] = useState(false);
  const [profile, setProfile] = useState([]);
  const [stats, setStats] = useState([]);
  const navigate=useNavigate ()


  useEffect(() => { const t = setTimeout(() => setShow(true), 10); return () => clearTimeout(t); }, []);

  useEffect(()=>{
    if (show) {
      loadProfile();
    }
  },[show])

  const loadProfile=()=>{
    axios.get(process.env.REACT_APP_API_SERVER + 'manager/dashboard/userprofile/'+player.UUID, {
      headers: { 'Authorization': 'Bearer ' + sessionStorage.getItem("mngapiToken") }
    })
      .then(res => {
        setProfile(res.data.results);
        loadStats();
      }).catch(err => {

      });
  };
  


  const loadStats=()=>{
    axios.get(process.env.REACT_APP_API_SERVER + 'manager/dashboard/userstats/'+player.UUID, {
      headers: { 'Authorization': 'Bearer ' + sessionStorage.getItem("mngapiToken") }
    })
      .then(res => {
        //console.log(res.data.results);
        setStats(res.data.results);
      }).catch(err => {

      });
  };


  const close = () => { setShow(false); setTimeout(onClose, 300); };
  //console.log(player);
  return (
    <div onClick={close} style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", backdropFilter: "blur(5px)",
      display: "flex", alignItems: "center", justifyContent: "center", zIndex: 10000,
      opacity: show ? 1 : 0, transition: "opacity 0.3s ease",
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: "rgba(15,23,42,0.95)", border: "1px solid rgba(255,255,255,0.1)",
        borderRadius: 16, width: 650, maxWidth: "90vw", padding: 30,
        boxShadow: "0 20px 50px rgba(0,0,0,0.5)", position: "relative", color: "white",
        fontFamily: "'Inter',sans-serif",
        transform: show ? "translateY(0) scale(1)" : "translateY(20px) scale(0.95)",
        transition: "all 0.3s cubic-bezier(0.175,0.885,0.32,1.275)",
      }}>
        <button onClick={close} style={{ position: "absolute", top: 15, right: 15, background: "none", border: "none", color: "#94a3b8", fontSize: 24, cursor: "pointer" }}>
          <i className="fa-solid fa-xmark" />
        </button>




        <div style={{ display: "grid", gridTemplateColumns: "220px 1fr", gap: 25 }}>
          <img src={player.avatar_url} alt={player.fullname} style={{ width: "100%", borderRadius: 12, border: "2px solid #10b981" }} />

          <div>
            
              {/* <Button variant="link" onClick={()=>navigate('/user/'+player.UUID)}> */}
                <h2 style={{ fontSize: 24, margin: "0 0 5px", fontFamily: "'Outfit',sans-serif" }}>
                <Button variant="link" onClick={()=>navigate('/user/'+player.UUID)}
                  style={{ fontSize: 24, margin: "0 0 5px", fontFamily: "'Outfit',sans-serif",color:"#f0f0f0" }}  
                >
                {player.fullname}
                </Button>
                </h2>
              {/* </Button> */}
            
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
              <span style={{ display: "inline-block", background: "rgba(16,185,129,0.2)", color: "#10b981", padding: "4px 10px", borderRadius: 4, fontSize: 13, fontWeight: 700 }}>
                {player.position}
              </span>
              {isOnCourt ? (
                <button
                  onClick={() => { onRemove(player.id); onClose(); }}
                  onMouseEnter={e => e.currentTarget.style.background = "rgba(239,68,68,0.3)"}
                  onMouseLeave={e => e.currentTarget.style.background = "rgba(239,68,68,0.15)"}
                  style={{ background: "rgba(239,68,68,0.15)", border: "1px solid #ef4444", color: "#ef4444", padding: "4px 12px", borderRadius: 4, fontSize: 13, fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", gap: 6, transition: "background 0.2s ease" }}
                >
                  <i className="fa-solid fa-xmark" /> Remove from Court
                </button>
              ) : (
                <button
                  onClick={() => { onClose(); onPlace(player); }}
                  onMouseEnter={e => e.currentTarget.style.background = "rgba(59,130,246,0.3)"}
                  onMouseLeave={e => e.currentTarget.style.background = "rgba(59,130,246,0.15)"}
                  style={{ background: "rgba(59,130,246,0.15)", border: "1px solid #3b82f6", color: "#3b82f6", padding: "4px 12px", borderRadius: 4, fontSize: 13, fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", gap: 6, transition: "background 0.2s ease" }}
                >
                  <i className="fa-solid fa-arrow-down-to-line" /> Place on Court
                </button>
              )}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 20 }}>
              {[["Age", moment().diff(moment(profile.DateOfBirthYMD), 'years') ], ["Tag", profile.Nickname], ["Height", `${profile.Height} cm`], ["Weight", `${profile.Weight} kg`], ["Country", profile.Country], ["Orientation", profile.LeftRight==1 ? "Right" : profile.LeftRight==1  ? "Left" : 'Both']].map(([lbl, val]) => (
                <div key={lbl} style={{ background: "rgba(255,255,255,0.05)", padding: "10px 12px", borderRadius: 8 }}>
                  <div style={{ color: "#94a3b8", fontSize: 11, textTransform: "uppercase", marginBottom: 4 }}>{lbl}</div>
                  <div style={{ fontWeight: 600, fontSize: 13 }}>{val || "—"}</div>
                </div>
              ))}
            </div>

            {stats.map(( stat, index) => {

              return (
                <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: 12, fontSize: 13 }}>
                  <span style={{ width: 150, color: "#94a3b8" }}>{stat.StatName}</span>
                  <div style={{ flex: 1, height: 6, background: "rgba(255,255,255,0.1)", borderRadius: 3, margin: "0 10px", overflow: "hidden" }}>
                    <div style={{ height: "100%", width: `${stat.Value}%`, background: "#10b981", borderRadius: 3, transition: "width 0.5s ease-out" }} />
                  </div>
                  <span style={{ fontWeight: 700, width: 35, textAlign: "right" }}>{stat.Value}</span>
                </div>
              );
            })}

            {/* {BBALL_STATS.map(({ key, label }) => {
              const val = player[key] || 0;
              return (
                <div key={key} style={{ display: "flex", alignItems: "center", marginBottom: 12, fontSize: 13 }}>
                  <span style={{ width: 150, color: "#94a3b8" }}>{label}</span>
                  <div style={{ flex: 1, height: 6, background: "rgba(255,255,255,0.1)", borderRadius: 3, margin: "0 10px", overflow: "hidden" }}>
                    <div style={{ height: "100%", width: `${val}%`, background: "#10b981", borderRadius: 3, transition: "width 0.5s ease-out" }} />
                  </div>
                  <span style={{ fontWeight: 700, width: 35, textAlign: "right" }}>{val}</span>
                </div>
              );
            })} */}

          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Team Pick Modal ──────────────────────────────────────────────────────────
function TeamPickModal({ player, onPick, onClose }) {
  const [show, setShow] = useState(false);
  useEffect(() => { const t = setTimeout(() => setShow(true), 10); return () => clearTimeout(t); }, []);
  const close = () => { setShow(false); setTimeout(onClose, 300); };
  const pick = (prefix) => { setShow(false); setTimeout(() => { onPick(player.id, prefix); onClose(); }, 300); };

  return (
    <div onClick={close} style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", backdropFilter: "blur(5px)",
      display: "flex", alignItems: "center", justifyContent: "center", zIndex: 10000,
      opacity: show ? 1 : 0, transition: "opacity 0.3s ease",
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: "rgba(15,23,42,0.95)", border: "1px solid rgba(255,255,255,0.1)",
        borderRadius: 16, width: 380, maxWidth: "90vw", padding: 30,
        boxShadow: "0 20px 50px rgba(0,0,0,0.5)", position: "relative", color: "white",
        fontFamily: "'Inter',sans-serif", textAlign: "center",
        transform: show ? "translateY(0) scale(1)" : "translateY(20px) scale(0.95)",
        transition: "all 0.3s cubic-bezier(0.175,0.885,0.32,1.275)",
      }}>
        <button onClick={close} style={{ position: "absolute", top: 15, right: 15, background: "none", border: "none", color: "#94a3b8", fontSize: 24, cursor: "pointer" }}>
          <i className="fa-solid fa-xmark" />
        </button>
        <img src={player.avatar_url} alt={player.fullname} style={{ width: 70, height: 70, borderRadius: "50%", objectFit: "cover", border: "2px solid #10b981", marginBottom: 12 }} />
        <h3 style={{ margin: "0 0 6px", fontFamily: "'Outfit',sans-serif", fontSize: 18 }}>{player.fullname}</h3>
        <p style={{ color: "#94a3b8", fontSize: 13, margin: "0 0 24px" }}>Place this player on which team?</p>
        <div style={{ display: "flex", gap: 12 }}>
          <button
            onClick={() => pick("home")}
            onMouseEnter={e => e.currentTarget.style.background = "rgba(59,130,246,0.3)"}
            onMouseLeave={e => e.currentTarget.style.background = "rgba(59,130,246,0.15)"}
            style={{ flex: 1, padding: "14px 10px", borderRadius: 10, border: "2px solid #3b82f6", background: "rgba(59,130,246,0.15)", color: "#3b82f6", cursor: "pointer", fontFamily: "'Inter',sans-serif", fontWeight: 700, fontSize: 14, transition: "all 0.2s ease" }}
          >
            <i className="fa-solid fa-arrow-left" style={{ marginRight: 8 }} />Starters
          </button>
          <button
            onClick={() => pick("away")}
            onMouseEnter={e => e.currentTarget.style.background = "rgba(239,68,68,0.3)"}
            onMouseLeave={e => e.currentTarget.style.background = "rgba(239,68,68,0.15)"}
            style={{ flex: 1, padding: "14px 10px", borderRadius: 10, border: "2px solid #ef4444", background: "rgba(239,68,68,0.15)", color: "#ef4444", cursor: "pointer", fontFamily: "'Inter',sans-serif", fontWeight: 700, fontSize: 14, transition: "all 0.2s ease" }}
          >
            Substitutes<i className="fa-solid fa-arrow-right" style={{ marginLeft: 8 }} />
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Drop Zone ────────────────────────────────────────────────────────────────
function DropZone({ zoneId, playerId, allPlayers, onDragStart, onDrop, onClickFilled, position, removePlayer }) {
  const [isDragOver, setIsDragOver] = useState(false);
  const player = playerId ? allPlayers.find(p => p.id == playerId) : null;
  const isHome = zoneId.startsWith("home");
  const color = isHome ? "#3b82f6" : "#ef4444";
  const glow  = isHome ? "rgba(59,130,246,0.4)" : "rgba(239,68,68,0.4)";

  return (
    <div
      onDragOver={e => { e.preventDefault(); setIsDragOver(true); }}
      onDragEnter={e => { e.preventDefault(); setIsDragOver(true); }}
      onDragLeave={() => setIsDragOver(false)}
      onDrop={e => { setIsDragOver(false); onDrop(e, zoneId); }}
      onClick={player ? () => onClickFilled(player.id) : undefined}
      style={{
        position: "absolute", top: position.top, left: position.left,
        transform: `translate(-50%,-50%) ${isDragOver ? "scale(1.1)" : "scale(1)"}`,
        width: 65, height: 65, borderRadius: "50%",
        border: `2px ${player ? "solid" : "dashed"} ${isDragOver ? "#f59e0b" : player ? color : "rgba(255,255,255,0.3)"}`,
        background: isDragOver ? "rgba(245,158,11,0.2)" : player ? "rgba(15,23,42,0.9)" : "rgba(0,0,0,0.4)",
        backdropFilter: "blur(4px)",
        display: "flex", alignItems: "center", justifyContent: "center",
        transition: "all 0.3s cubic-bezier(0.175,0.885,0.32,1.275)",
        boxShadow: player ? `0 0 15px ${glow}` : "none",
        cursor: player ? "pointer" : "default",
        pointerEvents: "auto",
      }}
    >
      {player ? (
        <>
          <img
            src={player.avatar_url} alt={player.fullname} draggable
            onDragStart={e => onDragStart(e, String(player.id), zoneId)}
            style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover" }}
          />
          <div style={{
            position: "absolute", bottom: -25, background: "rgba(0,0,0,0.8)", color: "white",
            fontSize: 11, padding: "3px 8px", borderRadius: 10, whiteSpace: "nowrap",
            border: "1px solid rgba(255,255,255,0.2)", fontWeight: 600,
            display: "flex", alignItems: "center", gap: 4,
          }}>
            {player.fullname.trim().split(/\s+/).pop()} 
            {/* {player.position.trim()} */}
            <button
              onClick={e => { e.stopPropagation(); removePlayer(player.id); }}
              style={{ background: "none", border: "none", color: "#ef4444", cursor: "pointer", padding: "0 2px", fontSize: 10, lineHeight: 1, fontWeight: 700 }}
            >✕</button>
          </div>
        </>
      ) : (
        <span style={{ fontSize: 13, fontWeight: 800, color: "rgba(255,255,255,0.5)" }}>
          {position.label}
        </span>
      )}
    </div>
  );
}

// ─── Player Card ──────────────────────────────────────────────────────────────
function PlayerCard({ player, onDragStart, onClick, onDoubleClick }) {
  const [hovered, setHovered] = useState(false);
  const clickTimer = useRef(null);

  const handleClick = () => {
    clearTimeout(clickTimer.current);
    clickTimer.current = setTimeout(() => onClick(player.id), 250);
  };
  const handleDoubleClick = () => {
    clearTimeout(clickTimer.current);
    onDoubleClick(player.id);
  };

  return (
    <li
      draggable
      onDragStart={e => onDragStart(e, String(player.id), null)}
      onClick={handleClick}
      onDoubleClick={handleDoubleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        listStyle: "none",
        background: hovered ? "rgba(255,255,255,0.08)" : "rgba(255,255,255,0.03)",
        border: "1px solid rgba(255,255,255,0.1)", borderRadius: 10, padding: 10,
        display: "flex", alignItems: "center", gap: 12, cursor: "grab",
        transform: hovered ? "translateX(5px)" : "translateX(0)",
        transition: "all 0.2s ease",
      }}
    >
      <img src={player.avatar_url} alt={player.fullname} style={{
        width: 45, height: 45, borderRadius: "50%", objectFit: "cover",
        border: `2px solid ${player.team_id === 1 ? "#3b82f6" : "#ef4444"}`,
        flexShrink: 0,
      }} />




      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 2 }}>{player.fullname} ({player.StatsOverall})</div>
        <div style={{ fontSize: 11, color: "#94a3b8", background: "rgba(255,255,255,0.1)", padding: "2px 6px", borderRadius: 4, display: "inline-block" }}>{player.position}</div>
      </div>
    </li>
  );
}

// ─── Stat Card ────────────────────────────────────────────────────────────────
function StatCard({ title, color, teamStats }) {
  return (
    <div style={{ background: "rgba(0,0,0,0.2)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 12, padding: 15 }}>
      <h3 style={{ fontSize: 15, margin: "0 0 12px", color, display: "flex", justifyContent: "space-between" }}>
        <span>{title}</span>
        <span style={{ color: "#94a3b8", fontSize: 13 }}>{teamStats.count}/5</span>
      </h3>
      {teamStats.stats.map(({ key, label, avg }) => (
        <div key={key} style={{ display: "flex", alignItems: "center", marginBottom: 8, fontSize: 11 }}>
          <span style={{ width: 90, color: "#94a3b8", flexShrink: 0 }}>{label}</span>
          <div style={{ flex: 1, height: 6, background: "rgba(255,255,255,0.1)", borderRadius: 3, margin: "0 10px", overflow: "hidden" }}>
            <div style={{ height: "100%", width: `${avg}%`, background: statBarColor(avg), transition: "width 0.5s ease-out", borderRadius: 3 }} />
          </div>
          <span style={{ fontWeight: 700, width: 35, textAlign: "right" }}>{avg}</span>
        </div>
      ))}
    </div>
  );
}

// ─── Root Component ───────────────────────────────────────────────────────────
export default function ProScoutElite() {
  const [playersData, setPlayersData] = useState(MOCK_PLAYERS);
  const [courtState, setCourtState] = useState(INITIAL_COURT);
  const [currentTab, setCurrentTab] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [modalPlayer, setModalPlayer] = useState(null);
  const [teamPickPlayer, setTeamPickPlayer] = useState(null);
  const [toast, setToast] = useState(null);
  const dragData = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const { selectedList, setSelectedList } = useContext(UserContext);
  const { fieldTeam, setFieldTeam } = useContext(UserContext);

  const [countries, setCountries] = useState([]);
  const [positions, setPositions] = useState([]);
  const [a1, setA1] = useState(0);
  const [a2, setA2] = useState(0);
  const [h1, setH1] = useState(0);
  const [h2, setH2] = useState(0);
  const [w1, setW1] = useState(0);
  const [w2, setW2] = useState(0);
  const [o, setO] = useState(0);
  const [s, setS] = useState('');

  useEffect(() => {
    //loadLists();
    const savedCourt = localStorage.getItem("courtState");
    const savedList = localStorage.getItem("selectedList");
    if (savedCourt) setCourtState(JSON.parse(savedCourt));
    // if (savedList) {
    //   setSelectedList(savedList);
       loadList();
    // }
  }, []);

  useEffect(() => {
    localStorage.setItem("courtState", JSON.stringify(courtState));
  }, [courtState]);

  useEffect(() => {
    localStorage.setItem("selectedList", selectedList);
  }, [selectedList]);

  // useEffect(() => {
  //   createSQL();
  // }, [countries]);



  const loadList = () => {
    setIsLoading(true);
    const SportID = sessionStorage.getItem('SportID');
    const CountryIDS=sessionStorage.getItem('appCountries') ? JSON.parse(sessionStorage.getItem('appCountries')).map(c=>(c.value)) : [];
    axios.post(process.env.REACT_APP_API_SERVER + 'manager/listscriteria/results/court',{SportID,CountryIDS}, {
      headers: { 'Authorization': 'Bearer ' + sessionStorage.getItem("mngapiToken") }
    })
      .then(res => {
        if (res.data.err == 0) {
            const listResults = res.data.results.sort((a, b) => b.StatsOverall - a.StatsOverall)
            console.log(listResults);
            const resForCourt=listResults.map(player => ({
              UUID: player.UUID,
              //xid: player.id,
              id: player.UUID,
              fullname: `${player.FirstName.trim()} ${player.LastName.trim()}`,
              position: player.Position,
              team_id: 1,
              avatar_url: `${process.env.REACT_APP_API_SERVER}files/${player.UUID}/123`,
              StatsOverall: player.StatsOverall ? player.StatsOverall : 0,
              Speed: player.stats.Speed ? player.stats.Speed : 0,
              Ball_handling: player.stats.Ball_handling ? player.stats.Ball_handling : 0,
              Percentage_2pt: player.stats.Percentage_2pt ? player.stats.Percentage_2pt : 0,
              Percentage_3pt: player.stats.Percentage_3pt ? player.stats.Percentage_3pt : 0,
              Percentage_FT: player.stats.Percentage_FT ? player.stats.Percentage_FT : 0,
            })).sort((a, b) => b.StatsOverall - a.StatsOverall)
            setPlayersData(resForCourt);
            //console.log(resForCourt);
        } else {
          alert('An error has occured');
        }
        setIsLoading(false);
      }).catch(err => {
        setIsLoading(false);
        console.log(err);
      });
  };

 

  const removePlayer = useCallback((playerID) => {
    setCourtState(prev => {
      const next = { ...prev };
      Object.keys(next).forEach(zoneID => {
        if (next[zoneID] == playerID) next[zoneID] = null;
      });
      return next;
    });
    setFieldTeam(prev => prev.filter(p => p.id != playerID));
  }, [setFieldTeam]);

  const handleReset = () => {
    if (window.confirm("Are you sure you want to reset the court? This cannot be undone.")) {
      setCourtState(INITIAL_COURT);
      setFieldTeam([]);
    }
  };

  const showToast = useCallback(msg => setToast(msg), []);

  const assignedIds = new Set(Object.values(courtState).filter(Boolean).map(String));
  const visiblePlayers = playersData.filter(p =>
    p.team_id === currentTab &&
    (p.fullname.toLowerCase().includes(searchText.toLowerCase()) || p.position.toLowerCase().includes(searchText.toLowerCase()))&&
    !assignedIds.has(String(p.id))
  );
  const homePlayers = ["home-1","home-2","home-3","home-4","home-5"].map(k => courtState[k]).filter(Boolean);
  const awayPlayers = ["away-1","away-2","away-3","away-4","away-5"].map(k => courtState[k]).filter(Boolean);
  const homeStats   = calcTeamStats(homePlayers, playersData);
  const awayStats   = calcTeamStats(awayPlayers, playersData);
  const insight     = generateInsight(homeStats, awayStats);

  const handleDragStart = useCallback((e, playerId, sourceZone) => {
    dragData.current = { playerId, sourceZone };
    e.dataTransfer.effectAllowed = "move";
  }, []);

  const handleDrop = useCallback((e, zoneId) => {
    e.preventDefault();
    if (!dragData.current) return;
    const { playerId, sourceZone } = dragData.current;
    dragData.current = null;

    const player = playersData.find(p => p.id == playerId);
    if (!player) return;

    const expectedPos = BBALL_ZONES[zoneId]?.label;
    if (!positionMatches(player.position, expectedPos)) {
      showToast(`Position Mismatch! Zone needs ${expectedPos}, player is ${player.position}.`);
      return;
    }

    const playerObject = {
      id: player.UUID || player.id,
      zoneID: zoneId,
      userUUID: sessionStorage.getItem('userToken'),
    };
    setFieldTeam(prev => [...prev.filter(p => p.zoneID !== zoneId), playerObject]);

    setCourtState(prev => {
      const next = { ...prev };
      if (sourceZone && sourceZone !== zoneId) next[sourceZone] = null;
      next[zoneId] = String(playerId);
      return next;
    });
  }, [playersData, showToast, setFieldTeam]);

  const handleAutoPlace = useCallback((playerId, prefix) => {
    const player = playersData.find(p => p.id == playerId);
    if (!player) return;
    for (let i = 1; i <= 5; i++) {
      const zId = `${prefix}-${i}`;
      if (!courtState[zId] && positionMatches(player.position, BBALL_ZONES[zId]?.label)) {
        setCourtState(prev => ({ ...prev, [zId]: String(player.id) }));
        return;
      }
    }
    showToast(`No empty ${player.position} positions available!`);
  }, [playersData, courtState, showToast]);

  const listsList = lists.map((list, index) => (
    <option key={index} value={list.UUID}>{list.listName}</option>
  ));

  return (
    <>
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&family=Outfit:wght@400;700;900&display=swap" rel="stylesheet" />
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />

      {isLoading && (
        <Alert variant="secondary" style={{ margin: 20 }}>Loading, please wait...</Alert>
      )}
      {!isLoading && (
        <div style={{
          fontFamily: "'Inter',sans-serif", color: "#f8fafc", height: "100vh",
          overflow: "hidden", display: "flex", flexDirection: "column",
          background: "#0f172a",
          backgroundImage: "radial-gradient(circle at 15% 50%,rgba(59,130,246,0.15),transparent 25%),radial-gradient(circle at 85% 30%,rgba(239,68,68,0.1),transparent 25%)",
        }}>
          <div style={{ display: "flex", flex: 1, overflow: "hidden" }}>

            {/* Left sidebar */}
            <aside style={{
              width: 300, flexShrink: 0,
              background: "rgba(30,41,59,0.7)", backdropFilter: "blur(10px)",
              borderRight: "1px solid rgba(255,255,255,0.1)",
              display: "flex", flexDirection: "column", overflow: "hidden",
            }}>
              <div style={{ padding: 20, borderBottom: "1px solid rgba(255,255,255,0.1)", flexShrink: 0 }}>
                <h2 style={{ fontFamily: "'Outfit',sans-serif", fontSize: 18, display: "flex", alignItems: "center", gap: 10, margin: "0 0 4px" }}>
                  <i className="fa-solid fa-users" /> Roster
                </h2>
                <p style={{ fontSize: 12, color: "#94a3b8", margin: "0 0 12px" }}>Double-click to place on a team</p>


                <div style={{ position: "relative" }}>
                  <i className="fa-solid fa-search" style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#94a3b8" }} />
                  <input
                    type="text" placeholder="Search player..." value={searchText}
                    onChange={e => setSearchText(e.target.value)}
                    style={{
                      width: "100%", boxSizing: "border-box",
                      background: "rgba(0,0,0,0.3)", border: "1px solid rgba(255,255,255,0.1)",
                      color: "white", padding: "10px 10px 10px 35px", borderRadius: 8,
                      outline: "none", fontFamily: "'Inter',sans-serif",
                    }}
                  />
                </div>
              </div>
              <div style={{ flex: 1, minHeight: 0, overflowY: "auto", overflowX: "hidden", padding: 15 }}>
                <ul style={{ listStyle: "none", margin: 0, padding: 0, display: "flex", flexDirection: "column", gap: 10 }}>
                  {visiblePlayers.map(p => (
                    <PlayerCard key={p.id} player={p} onDragStart={handleDragStart} onClick={id => setModalPlayer(playersData.find(pl => pl.id == id))} onDoubleClick={id => setTeamPickPlayer(playersData.find(pl => pl.id == id))} />
                  ))}
                  {!visiblePlayers.length && (
                    <li style={{ color: "#94a3b8", textAlign: "center", fontSize: 13, paddingTop: 20 }}>
                      {searchText ? "No players found." : "All players placed on court!"}
                    </li>
                  )}
                </ul>
              </div>
            </aside>

            {/* Court */}
            <main style={{
              flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
              background: "radial-gradient(circle at center,#1e293b,#0f172a)", padding: 40, gap: 15,
            }}>
              <Button variant="outline-danger" size="sm" onClick={handleReset}>
                Reset Court
              </Button>
              <div style={{ width: "100%", maxWidth: 900, aspectRatio: "16/9" }}>
                <div style={{
                  width: "100%", height: "100%", position: "relative",
                  backgroundImage: `url(${courtImage})`,
                  backgroundSize: "cover", backgroundPosition: "center",
                  borderRadius: 20,
                  boxShadow: "0 20px 50px rgba(0,0,0,0.5),inset 0 0 100px rgba(0,0,0,0.6)",
                  border: "3px solid rgba(255,255,255,0.1)",
                }}>
                  <div style={{
                    position: "absolute", left: "50%", top: "50%",
                    transform: "translate(-50%,-50%)", fontSize: 60,
                    color: "rgba(255,255,255,0.08)", pointerEvents: "none", zIndex: 1,
                  }}>
                    <i className="fa-solid fa-basketball" />
                  </div>
                  <div style={{ position: "absolute", inset: 0, pointerEvents: "none", zIndex: 5 }}>
                    {Object.entries(BBALL_ZONES).map(([zoneId, pos]) => (
                      <DropZone
                        key={zoneId} zoneId={zoneId}
                        playerId={courtState[zoneId]}
                        allPlayers={playersData}
                        onDragStart={handleDragStart}
                        onDrop={handleDrop}
                        onClickFilled={id => setModalPlayer(playersData.find(p => p.id == id))}
                        position={pos}
                        removePlayer={removePlayer}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </main>

            {/* Right sidebar */}
            <aside style={{
              width: 320, flexShrink: 0,
              background: "rgba(30,41,59,0.7)", backdropFilter: "blur(10px)",
              borderLeft: "1px solid rgba(255,255,255,0.1)",
              display: "flex", flexDirection: "column",
            }}>
              <div style={{ padding: 20, borderBottom: "1px solid rgba(255,255,255,0.1)", flexShrink: 0 }}>
                <h2 style={{ fontFamily: "'Outfit',sans-serif", fontSize: 18, display: "flex", alignItems: "center", gap: 10, margin: "0 0 5px" }}>
                  <i className="fa-solid fa-chart-line" /> Analytics
                </h2>
                <p style={{ fontSize: 13, color: "#94a3b8", margin: 0 }}>Live Coaching Stats</p>
              </div>
              <div style={{ flex: 1, overflowY: "auto", padding: 15, display: "flex", flexDirection: "column", gap: 15 }}>
                <StatCard title="🔵 Starters"    color="#3b82f6" teamStats={homeStats} />
                <div style={{ textAlign: "center", fontFamily: "'Outfit',sans-serif", fontWeight: 900, color: "rgba(255,255,255,0.1)", fontSize: 20, letterSpacing: 2 }}>VS</div>
                <StatCard title="🔴 Substitutes" color="#ef4444" teamStats={awayStats} />
                <div style={{
                  background: "linear-gradient(135deg,rgba(139,92,246,0.1),rgba(0,0,0,0.3))",
                  border: "1px solid rgba(139,92,246,0.3)", borderRadius: 12, padding: 15,
                }}>
                  <h3 style={{ fontSize: 14, color: "#a78bfa", margin: "0 0 8px", display: "flex", alignItems: "center", gap: 8 }}>
                    <i className="fa-solid fa-brain" /> Scout AI Insight
                  </h3>
                  <p style={{ fontSize: 13, color: "#94a3b8", lineHeight: 1.5, margin: 0 }}>{insight}</p>
                </div>
              </div>
            </aside>
          </div>
        </div>
      )}

      {modalPlayer && <PlayerModal player={modalPlayer} onClose={() => setModalPlayer(null)} onPlace={p => { setModalPlayer(null); setTeamPickPlayer(p); }} isOnCourt={assignedIds.has(String(modalPlayer.id))} onRemove={removePlayer} />}
      {teamPickPlayer && <TeamPickModal player={teamPickPlayer} onPick={handleAutoPlace} onClose={() => setTeamPickPlayer(null)} />}
      {toast && <Toast message={toast} onDone={() => setToast(null)} />}
    </>
  );
}
